const defaultTitle = "Can't process your payment";
const secondTitle = "Looks like we can't use this method for payments";

export const errorsTexts: Record<string, { title: string; text: string }> = {
  default: {
    title: 'Can’t process your payment',
    text: 'Please try again. If the problem persists, message us via the in-app chat or at support@welltory.com',
  },
  invoice_payment_intent_requires_action: {
    title: defaultTitle,
    text: 'Seems like extra confirmation is needed. Look for any notifications or requests sent by your bank to confirm your transaction',
  },
  payment_intent_action_required: {
    title: defaultTitle,
    text: "Looks like your payment method requires two-factor authentication we can't process. Please choose a different payment method and try again",
  },
  payment_intent_authentication_failure: {
    title: defaultTitle,
    text: 'There seems to be a problem with this payment method. Please choose a different one and try again',
  },
  payment_intent_incompatible_payment_method: {
    title: defaultTitle,
    text: 'There seems to be a problem with this payment method. Please update your payment info and try again',
  },
  payment_intent_invalid_parameter: {
    title: defaultTitle,
    text: "The payment info you provided doesn't look right. Please update it and try again",
  },
  payment_intent_konbini_rejected_confirmation_number: {
    title: defaultTitle,
    text: "We couldn't confirm your identity to process your payment. Please make sure you enter your payment info correctly and try again",
  },
  payment_intent_mandate_invalid: {
    title: defaultTitle,
    text: "The payment confirmation you provided doesn't look right. Please try again and make sure you enter your payment info correctly",
  },
  payment_intent_payment_attempt_expired: {
    title: defaultTitle,
    text: 'The latest payment attempt has expired. Please choose a different payment method and try again',
  },
  payment_intent_payment_attempt_failed: {
    title: defaultTitle,
    text: 'The latest payment attempt has failed. Please choose a different payment method and try again',
  },
  payment_intent_unexpected_state: {
    title: defaultTitle,
    text: "Looks like we can't use this payment method. Please choose a different payment method and try again",
  },
  payment_method_bank_account_already_verified: {
    title: defaultTitle,
    text: "Looks like you've verified your bank account already, but our system was not able to charge it. Please clear your cache and cookies and try again",
  },
  payment_method_bank_account_blocked: {
    title: defaultTitle,
    text: "This bank account has failed verification in the past, and we can't charge it. Please choose a different payment method and try again",
  },
  payment_method_billing_details_address_missing: {
    title: defaultTitle,
    text: 'Looks like your billing address is missing something. Please make sure you fill out your address correctly and try again',
  },
  payment_method_currency_mismatch: {
    title: defaultTitle,
    text: "Looks like the currency you specified doesn't match the currency for your payment method. Please make sure they match and try again",
  },
  payment_method_invalid_parameter: {
    title: defaultTitle,
    text: "The payment info you provided doesn't look right. Please update it and try again",
  },
  payment_method_microdeposit_failed: {
    title: defaultTitle,
    text: "Looks like we can't send you micro-deposits — small sums of money placed in your bank account to verify a secure connection with our payment system. Please make sure your account number and payment info are correct and try again",
  },
  payment_method_microdeposit_verification_amounts_invalid: {
    title: defaultTitle,
    text: "Looks like the second micro-deposit didn’t show up, and we can't verify your bank account. Please make sure you received exactly two micro-deposits and provide them to proceed",
  },
  payment_method_microdeposit_verification_amounts_mismatch: {
    title: defaultTitle,
    text: "Looks like the micro-deposit amounts you provided don't match the ones we've sent you. Please try to verify this payment method again or go with another one",
  },
  payment_method_microdeposit_verification_attempts_exceeded: {
    title: defaultTitle,
    text: "Sorry, you've used all attempts to verify this payment method with micro-deposits. Please choose a different payment method and try again",
  },
  payment_method_microdeposit_verification_descriptor_code_mismatch: {
    title: defaultTitle,
    text: "The code you provided to verify your account with micro-deposits doesn't look right. Please try to verify this payment method again or go with another one",
  },
  payment_method_microdeposit_verification_timeout: {
    title: defaultTitle,
    text: 'Sorry, your verification code has expired. Please try to verify your payment again or go with another payment method',
  },
  payment_method_provider_decline: {
    title: defaultTitle,
    text: "Looks like your bank issuer didn't validate your purchase. Please try again with a different payment method or contact your bank",
  },
  payment_method_unactivated: {
    title: secondTitle,
    text: 'Please try again with a different payment method',
  },
  payment_method_unexpected_state: {
    title: secondTitle,
    text: 'Please try again with a different payment method',
  },
  invoice_no_payment_method_types: {
    title: secondTitle,
    text: 'Please try again with a different payment method or message us via in-app chat or at support@welltory.com',
  },
  incorrect_address: {
    title: "Your card's address doesn't look right",
    text: 'Please try again with a correct billings address or use a different payment method',
  },
  incorrect_cvc: {
    title: "Your card's security code doesn't look right",
    text: 'Please double-check the CVC security code or use a different payment method',
  },
  incorrect_number: {
    title: "Your card number doesn't look right",
    text: 'Please re-enter your card number or use a different payment method',
  },
  incorrect_zip: {
    title: "Your card's postal code doesn't look right",
    text: 'Please try again with a correct postal code or use a different payment method',
  },
  invalid_cvc: {
    title: "Your card's security code doesn't look right",
    text: 'Please double-check the CVC security code or use a different payment method',
  },
  invalid_expiry_month: {
    title: "Your card's expiration month doesn't look right",
    text: "Please re-enter your card's expiration month or use a different payment method",
  },
  invalid_expiry_year: {
    title: "Your card's expiration year doesn't look right",
    text: "Please re-enter your card's expiration year or use a different payment method",
  },
  invalid_number: {
    title: "Your card number doesn't look right",
    text: 'Please re-enter your card number or use a different payment method',
  },
  processing_error: {
    title: "Can't process your card",
    text: 'Please try paying with this card a bit later or use a different payment method',
  },
  card_declined: {
    title: 'Sorry, your card was declined',
    text: "No worries. Maybe there’s a typo in your card details, or you've exceeded the balance or limit available. Please make sure everything is okay and try again with this card or use a different payment method. If the problem persists, contact your bank",
  },
  expired_card: {
    title: 'Sorry, your card has expired',
    text: 'Please try again with a different payment method',
  },
};
